var map = {
	"./logo_giant-white.png": 1972,
	"./logo_innovative-white.png": 714,
	"./logo_mastery-white.png": 7564,
	"./logo_report-white.png": 6617,
	"./logo_science-white.png": 7633,
	"./logo_technology-white.png": 8097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6196;